<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <div v-if="showAlert == true">
          <alert-empty></alert-empty>
        </div>

        <v-widget
          class="px-0"
          :key="indexChart"
          :title="tituloGrafica"
          content-bg="white"
        >
          <div slot="widget-content">
            <e-chart
              :path-option="[
                ['dataset.source', res],
                ['tooltip.trigger', 'axis'],
                ['tooltip.axisPointer', { type: 'shadow' }],
                [
                  'color',
                  [color.lightBlue.base, color.orange.base, color.grey.base],
                ],
                ['legend.show', true],
                ['xAxis.axisLabel.show', true],
                ['xAxis.type', 'value'],
                ['yAxis.axisLabel.show', true],
                ['yAxis.type', 'category'],
                ['yAxis.data', regiones],
                ['grid.left', '3%'],
                ['grid.bottom', '3%'],
                ['grid.right', '4%'],
                ['series[0].type', 'bar'],
                ['series[0].areaStyle', {}],
                ['series[0].areaStyle', {}],
                //  ['series[0].label', {normal: { show: true, position: 'insideRight'} }],
                ['series[0].smooth', true],
                ['series[1].type', 'bar'],
                ['series[1].areaStyle', {}],
                ['series[1].smooth', true],
                //['series[1].label', {normal: { show: true, position: 'insideRight'} }],
                ['series[2].type', 'bar'],
                ['series[2].areaStyle', {}],
                ['series[2].smooth', true],
                //['series[2].label', {normal: { show: true, position: 'insideRight'} }],
              ]"
              height="400px"
              width="100%"
            ></e-chart>
          </div>
        </v-widget>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import API from "@/api";
import Util from "@/util";
import EChart from "@/components/chart/echart";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import CircleStatistic from "@/components/widgets/statistic/CircleStatistic";
import axios from "axios";
import { mapState } from "vuex";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  components: {
    VWidget,
    EChart,
    CircleStatistic,
    Loading,
    AlertEmpty,
  },
  mixins: [misMixins],
  props: {
    nivel: "",
    nivelNombre: "",
    periodo: "",
    proveedor: "",
  },
  data: () => ({
    nivel: "",
    fechaValue: "",
    dataPorcentaje: false,
    dataProductos: false,
    showAlert: false,
    loading: false,
    color: Material,
    contratoId: "",
    selectedTab: "tab-1",
    pruebasImd: [],
    pruebasProductos: [],
    pruebasMateriales: [],
    pruebasVisitas: [],
    dataReady: false,
    res: "",
    indexChart: 0,
    btnHidden: true,
    botonHidden: false,
    subProceso: "",
    tituloGrafica: "",
    id: "",
  }),
  computed: {},
  created() {
    this.id = this.$route.params.id;

    this.filter();
  },
  mounted() {},
  methods: {
    filter() {
      this.loadData();
    },
    async loadData() {
      this.loading = true;
      //dibujar la grafica
      this.pruebasImd = [];
      this.pruebasImd = await this.loadFilter();
      if (this.pruebasImd.length > 0) {
        this.showAlert = false;
        this.loadFechaSelect();
        this.loadHoraSelect();
        this.chartData();
      } else {
        this.showAlert = true;
      }
      this.loading = false;
    },
    chartData() {
      this.tituloGrafica =
        "Evolución Aplicación Cursos  IdNivel:" +
        this.nivelNombre +
        " " +
        " / Fecha : " +
        this.fechaValue +
        " " +
        this.horaValue;
      let data = [];
      this.pruebasImd.forEach((m) => {
        data.push({
          regiones: m.region,
          Aplicados: m.porcCursosAplicados.toFixed(2),
          "Emergentes Aplicados": m.porcCurEmergAplicados.toFixed(2),
          "No Aplicados": m.porcCurNoAplicados.toFixed(2),
        });
      });
      this.res = data;
      this.indexChart += 1;
    },
    async loadFilter() {
      //alert("Cursos  IdNivel");
      if (
        this.periodo != null &&
        this.proveedor != null &&
        this.nivel != null
      ) {
        return await axios
          .get(
            "/reportes/diaAplicacion/DSProv/" +
              this.nivel +
              "/" +
              this.periodo +
              "/" +
              this.proveedor
          )
          .then(function (response) {
            return response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        return await axios
          .get("/reportes/diaAplicacion/DS/" + this.nivel + "/" + this.periodo)
          .then(function (response) {
            return response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    loadFechaSelect() {
      let niv = [];
      this.pruebasImd.forEach(function (c) {
        let index = niv.findIndex((x) => x.fecha == c.fecha);
        if (index === -1) {
          if (c.fecha != null && c.fecha != "") {
            niv.push(c.fecha);
          }
        }
      });
      this.fechaSelect = niv[0];
      this.fechaValue = niv[0];
    },
    loadHoraSelect() {
      let hr = [];
      this.pruebasImd.forEach(function (c) {
        let index = hr.findIndex((x) => x.hora == c.hora);
        if (index === -1) {
          if (c.hora != null && c.hora != "") {
            hr.push(c.hora);
          }
        }
      });
      this.horaSelect = hr[0];
      this.horaValue = hr[0];
    },
  },
};
</script>
